const { debounce } = window.BAO.Utils

class StoreSwitcher extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['search', 'country', 'countries']
  }

  connectedCallback () {
    super.connectedCallback()

    this.allCountries = this.els.country.elements
  }

  setupListeners () {
    super.setupListeners()

    this.handleInput = this.handleInput.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    this.listeners.add(
      this.els.search.element,
      'input',
      debounce((e) => this.handleInput(e), 500),
    )

    if (this.els.submit?.exists) {
      this.listeners.add(this.els.submit.element, 'submit', this.handleSubmit)
    }
  }

  performSearch (searchTerm) {
    const countryElements = this.els.country.elements
    let hasMatches = false

    for (const countryElement of countryElements) {
      const countryName = countryElement.textContent.toLowerCase()
      const isMatch = countryName.includes(searchTerm.toLowerCase())

      countryElement.parentElement.style.display = isMatch ? '' : 'none'
      if (isMatch) hasMatches = true
    }

    if (this.els.noResults?.exists) {
      this.els.noResults.element.setAttribute('aria-hidden', hasMatches)
    }
  }

  handleInput (event) {
    const searchTerm = event.target.value

    this.performSearch(searchTerm)
  }

  handleSubmit (event) {
    event.preventDefault()

    const searchInput = this.els.search.element

    this.performSearch(searchInput.value)
  }

  clearSearch () {
    this.els.search.element.value = ''

    this.performSearch('')
  }
}

if (!customElements.get('store-switcher')) {
  customElements.define('store-switcher', StoreSwitcher)
}
